module.exports = __webpack_public_path__ + "static/img/aff2.56ae23c6.png";